import React, { useState, useEffect, useRef } from 'react';
import { StyledAmenitiesModalFilterDiv } from './index.styles';
// import { AmenitiesFiltersComponentsProps } from './../../index.types';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import {
  SearchFacetsConstants,
  SearchFacetsList,
  SearchFacetsListCodes,
} from '../../organisms/SearchResults/index.constant';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { Modal, usePortalStyle } from '@marriott/mi-ui-library';
import { AmenitiesFilterComponent } from '.';
import { getSearchAppliedFilter, SearchActions } from '../../organisms/SearchResults/store/store.action';
import {
  SearchStateExtendsType,
  SearchStateFilterObj,
  SearchFacetsResponse,
} from '../../organisms/SearchResults/store/store.type';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { isFilterStateEqual, updateQueryParams } from '../../organisms/SearchResults/lib/helper';
import { useConditionalPageContextSERP } from '../../hooks';
import { Button } from '@marriott/mi-ui-library';
import { useCheckBreakpoint } from '@marriott/mi-ui-library';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
import { MAP_VIEW_SESSION_KEY } from '../../modules/store/store.constants';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const AmenitiesModalComponent: React.FC<{
  filterData?: Array<SearchFacetsResponse>;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tooltipRefElement?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTooltipContent?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modalRefElement?: any;
  setShowToolTip?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  filterData,
  setFetchCurrencyConversionFactors,
  tooltipRefElement,
  setTooltipContent,
  modalRefElement,
  setShowToolTip,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, setFeatureSelected }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { searchQueryState, setSearchQuery, setFilterModalOpen } = useConditionalSearchFilterContextWithSerpFlag();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const { headersData } = useConditionalPageContextSERP();
  const [popupOpenState, setPopupOpenState] = useState(false);
  const clickTrackingLoc = 'Phoenix Search Results';
  const [filterSelectionData, setFilterSelectionData] = useState<SearchStateExtendsType>();
  const [currFilterData, setCurrFilterData] = useState<Array<SearchFacetsResponse> | undefined>(filterData);
  const amenities = searchQueryState?.filter?.filter(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (key: any) => key.type.code === SearchFacetsListCodes.amenities
  )[0];
  const isActive =
    searchQueryState[SearchFacetsList.amenities] &&
    Object.keys(searchQueryState[SearchFacetsList.amenities] ?? {}).length;

  const bodyRef = useRef<HTMLBodyElement | null>(null);
  const hasClearedRef = useRef(false);
  const isDesktop = useCheckBreakpoint('viewportM'); // check if viewport is desktop till 768px

  const { setContainerRef, PortalStyleProvider } = usePortalStyle();

  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;
  }, []);

  // Notify parent component about filter modal open/close state for body overflow control
  useEffect(() => {
    setFilterModalOpen?.(popupOpenState);
  }, [popupOpenState, setFilterModalOpen]);

  const onFilterChange = (type: SearchFacetsList, data: SearchStateFilterObj): void => {
    hasClearedRef.current = false; // Reset on new selection
    let arr1: SearchStateExtendsType = { ...filterSelectionData };
    if (filterSelectionData) {
      arr1[type] = data;
    } else {
      arr1 = {
        [type]: data,
      };
    }
    setFilterSelectionData(arr1);
    setInteractionsSelected({ ...interactionsSelected, amenities: true });
    setFetchCurrencyConversionFactors(true);
    eventUtil.dispatch('updateShopPageFilterModalValues', { ...searchQueryState, ...arr1 });
  };

  const applyBtnHandler = (): void => {
    const payload = filterSelectionData === undefined ? { [SearchFacetsList.amenities]: {} } : filterSelectionData;

    // Check if amenities filter actually changed - prevent unnecessary UXL calls
    const initialState = { [SearchFacetsList.amenities]: searchQueryState[SearchFacetsList.amenities] ?? {} };

    // Create newPayload for comparison - ensure AMENITIES key exists
    const newPayload =
      payload?.[SearchFacetsList.amenities] !== undefined
        ? payload
        : { [SearchFacetsList.amenities]: payload ?? {} };

    const hasFilterChanges = !isFilterStateEqual(initialState, newPayload);

    // Update the selected amenities filter values in the URL
    const amenities = Object.values((payload?.[SearchFacetsList.amenities] as SearchStateFilterObj) ?? {});

    updateQueryParams(
      {
        amenities,
      },
      ['amenities'],
      headersData?.referer
    );

    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: 0,
      },
    });
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });

    // Only call UXL if filters actually changed
    if (hasFilterChanges) {
      setSearchQuery({
        type: SearchActions.setQuery,
        payload: {
          [SearchFacetsConstants.facets]: {
            ...getSearchAppliedFilter(payload, searchQueryState),
          },
          [SearchFacetsConstants.options]: {
            ...searchQueryState.search[SearchFacetsConstants.options],
            [SearchFacetsConstants.includeTaxes]: searchQueryState[SearchFacetsConstants.includeTaxes],
            [SearchFacetsConstants.unavailableProperties]:
              searchQueryState[SearchFacetsConstants.unavailableProperties],
          },
        },
      });
    }
  };

  useEffect(() => {
    setCurrFilterData(filterData);
  }, [filterData]);

  return amenities?.buckets?.length ? (
    <PortalStyleProvider>
      <StyledAmenitiesModalFilterDiv ref={setContainerRef}>
        <Button
          callback={(): void => {
            hasClearedRef.current = false; // Reset on modal open
            setCurrFilterData(undefined);
            setPopupOpenState(!popupOpenState);
            setFilterSelectionData(searchQueryState[SearchFacetsList.amenities]);
          }}
          className={`m-button-primary-inverse t-label-alt-m button-secondary filter-option-button custom_click_track sm-search-result-all-filter-component-button ${
            isActive ? 'active' : ''
          }`}
          buttonCopy={amenities?.type.label ?? 'Amenities'}
          custom_click_track_value={`${clickTrackingLoc}| Filter Selection: Amenities |internal`}
        ></Button>

        {/* TODO - remove old markup after unit testing on environment */}
        {/* <button
        type="button"
        onClick={(): void => {
          setPopupOpenState(!popupOpenState);
          setFilterSelectionData(searchQueryState[SearchFacetsList.amenities]);
        }}
        className={
          't-label-alt-m filter-option-button custom_click_track sm-search-result-all-filter-component-button ' +
          (isActive ? 'active' : '')
        }
        {...{ custom_click_track_value: `${clickTrackingLoc}| Filter Selection: Amenities |internal` }}
      >
      {amenities?.type.label}*/}
        {/* <span className={`icon-dropdown-${popupOpenState?'up':'down'}`} /> */}
        {/*</button> */}
        {popupOpenState && (
          <Modal
            className={`custom-scrollbar  ${popupOpenState ? '' : 'close-popup-header'}`}
            show={true}
            handleBlur={true}
            popupOpenState={popupOpenState}
            setPopupOpenState={setPopupOpenState}
            allFilterPopUp={true}
            onClose={(): void => {
              setCurrFilterData(undefined);
            }}
            role="dialog"
            labelledBy="ModalPopup"
            modalId="ModalPopup"
            flexLayout={true}
            usePortal={true}
          >
            <Modal.Header
              // labelIcon=""
              labelText={jsonContent?.amenitiesLabel}
              // cancelLabel=""
              popupHeaderOnCLoseFunc={setPopupOpenState}
              customHeadingClass={isDesktop ? 't-subtitle-xl' : 't-subtitle-l'}
              flexLayout={true}
            >
              <div className="filter-by-title">{jsonContent?.amenitiesLabel}</div>
            </Modal.Header>
            <Modal.Body className="custom-scrollbar" refElement={modalRefElement} flexLayout={true}>
              <AmenitiesFilterComponent
                clearFilterState={filterSelectionData}
                onItemSelect={onFilterChange}
                allFilterPopUp={false}
                itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.amenities)[0]}
                tooltipRefElement={tooltipRefElement}
                setTooltipContent={setTooltipContent}
                modalRefElement={modalRefElement}
                setShowToolTip={setShowToolTip}
                isDesktop={isDesktop}
              />
            </Modal.Body>
            <Modal.Footer
              clearClickHandler={(): void => {
                const hasAppliedFilters = Object.keys(searchQueryState[SearchFacetsList.amenities] ?? {}).length > 0;
                const hasLocalSelections = filterSelectionData !== undefined &&
                  Object.keys(filterSelectionData?.[SearchFacetsList.amenities] ?? {}).length > 0;

                // Always clear UI selections (so checkboxes visually clear)
                setFilterSelectionData(undefined);
                setInteractionsSelected({ ...interactionsSelected, amenities: true });

                // Reset filter data if there are local selections OR applied filters (first time only)
                if (hasLocalSelections || (hasAppliedFilters && !hasClearedRef.current)) {
                  setCurrFilterData(undefined);
                }

                // Skip UXL call if no applied filters OR already cleared in this session
                if (!hasAppliedFilters || hasClearedRef.current) {
                  return;
                }

                hasClearedRef.current = true;
                setFetchCurrencyConversionFactors(true);
                eventUtil.dispatch('updateShopPageFilterModalValues', { ...searchQueryState, [SearchFacetsList.amenities]: {} });
              }}
              applyBtnClickHandler={applyBtnHandler}
              popupHeaderOnCLoseFunc={setPopupOpenState}
              clearButtonLabel={jsonContent.clearLabel}
              applyLabel={jsonContent.applyLabel}
              setFeatureSelected={setFeatureSelected}
              clickTrackingLoc={clickTrackingLoc}
              className={'pop-up-footer'}
              flexLayout={true}
            />
          </Modal>
        )}
      </StyledAmenitiesModalFilterDiv>
    </PortalStyleProvider>
  ) : null;
};
